/**
 * 입력 텍스트 앞의 불렛(-, •, *, 숫자.)을 제거하여 반환
 */
export function stripBullet(text: string): string {
  if (!text) return text;
  // 앞쪽 공백, 불렛 문자(-•*⚠), 숫자+점 패턴 제거
  return text.trim().replace(/^[\s]*[-•*⚠]\s*|^[\s]*\d+\.\s*/, '');
}

